import * as React from 'react'
import {useSelector} from 'react-redux'

import Box from 'airship/patterns/Box'
import Button from 'airship/patterns/button'

import {
  selectAppKey,
  selectAppName,
  selectProjectId,
  selectProjectName,
  selectUrl,
} from './selectors'

interface DetailsProps {
  setShowEditDetails: (val: boolean) => void
}

const Details: React.FC<DetailsProps> = ({setShowEditDetails}) => {
  const appName = useSelector(selectAppName)
  const url = useSelector(selectUrl)
  const appKey = useSelector(selectAppKey)
  const projectId = useSelector(selectProjectId)
  const projectName = useSelector(selectProjectName)

  const isWallet = typeof projectId !== 'undefined'

  return (
    <Box displayClasses="u-bg-grey-40 u-border-none u-border-radius-md u-pad-top-05 u-space-bottom-05">
      <p className="u-text-medium">
        Project name
        <span className="u-text-shrink-1 u-text-regular">
          {' '}
          {isWallet ? projectName : appName}
        </span>
      </p>
      <p className="u-text-medium">
        Page URL <span className="u-text-shrink-1 u-text-regular">{url}</span>
      </p>
      <p className="u-text-medium">
        {isWallet ? 'Wallet Project ID' : 'App key'}
        <span className="u-text-shrink-1 u-text-regular">
          {' '}
          {isWallet ? projectId : appKey}
        </span>
      </p>
      <Button
        onClick={() => setShowEditDetails(true)}
        displayClasses="u-space-top-05 u-bg-grey-50"
      >
        Edit details
      </Button>
    </Box>
  )
}

export default Details
